export default __webpack_public_path__ + "static/media/cert-fsi-consumer.215ecdf8.jpg";